'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../../prop-types/index.js');

var timeoutsShape = process.env.NODE_ENV !== 'production' ? index['default'].oneOfType([index['default'].number, index['default'].shape({
  enter: index['default'].number,
  exit: index['default'].number,
  appear: index['default'].number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? index['default'].oneOfType([index['default'].string, index['default'].shape({
  enter: index['default'].string,
  exit: index['default'].string,
  active: index['default'].string
}), index['default'].shape({
  enter: index['default'].string,
  enterDone: index['default'].string,
  enterActive: index['default'].string,
  exit: index['default'].string,
  exitDone: index['default'].string,
  exitActive: index['default'].string
})]) : null;

exports.classNamesShape = classNamesShape;
exports.timeoutsShape = timeoutsShape;
//# sourceMappingURL=PropTypes.js.map
